import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Col, ListGroup, Row } from "reactstrap"
import {
  checkCalendarCanBeDeleted,
  cloneCalendar,
  deleteCalendar,
  deleteSubCalendar,
  getAllCalendars,
  getAllSubCalendars,
  getCalendar,
  getBookingCalendars,
  getSubCalendar,
  hideCloneCalendarModal,
  hideCreateBookingModal,
  hideDeleteCalendarModal,
  hideDeleteSubCalendarModal,
  openCloneCalendarModal,
  openCreateBookingModal,
  openDeleteCalendarModal,
  openDeleteSubCalendarModal,
  reorderCalendars,
} from "store/actions"
import ModalComponent from "components/Modals"
import CalendarItem from "./CalendarItem"
import {
  closestCenter,
  DndContext,
  DragOverlay,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import { arrayMove, SortableContext } from "@dnd-kit/sortable"
import SortableCalendarItem from "./SortableCalendarItem"
import SubCalendarList from "./subCalendarList"

const CalendarList = ({
  allCalendars,
  allSubCalendars,
  handleOpenSubCalendar,
  handleOpenCalendar,
  getSubCalendar,
  getAllSubCalendars,
  cloneCalendar,
  cloneCalendarModalIsOpen,
  openCloneCalendarModal,
  hideCloneCalendarModal,
  vendorId,
  getBookingCalendars,
  getAllCalendars,
  loading,
  deleteCalendar,
  deleteCalendarModalIsOpen,
  openDeleteCalendarModal,
  hideDeleteCalendarModal,
  checkCalendarCanBeDeleted,
  calendarCanBeDeleted,
  getCalendar,
  deleteSubCalendar,
  openDeleteSubCalendarModal,
  hideDeleteSubCalendarModal,
  deleteSubCalendarModalIsOpen,
  openCreateBookingModal,
  setCalendar,
  setBookingCalendar,
  setBookingSubCalendar,
  reorderCalendars,
}) => {
  const [collapseItemIds, setCollapseItemIds] = useState({})
  const [calendarsState, setCalendarsState] = useState([])
  const [activeId, setActiveId] = useState(null)
  const [orderIsAsc, setOrderIsAsc] = useState(true)
  useEffect(() => {
    if (allCalendars?.length > 0) {
      if (allSubCalendars?.length === 0) {
        getAllSubCalendars({
          calendar_ids: allCalendars?.map(calendar => calendar?.id)?.toString(),
        })
      }
      let ids = {}
      allCalendars?.forEach(calendar => {
        ids = { ...ids, [calendar?.id]: true }
      })
      setCollapseItemIds(ids)
      let arr = [...allCalendars]
      setCalendarsState(arr.sort((a, b) => a.order - b.order))
    }
  }, [allCalendars])

  const [selectedCalendar, setSelectedCalendar] = useState()
  const [selectedSubCalendar, setSelectedSubCalendar] = useState()

  const collapseToggle = calendarId => {
    const currentStatus = collapseItemIds[calendarId]
    setCollapseItemIds({ ...collapseItemIds, [calendarId]: !currentStatus })
  }

  const handleBookSubCalendar = item => {
    setBookingCalendar(item?.calendar)
    setBookingSubCalendar(item)
    openCreateBookingModal()
  }

  const handleEditSubCalendar = item => {
    getSubCalendar({ id: item?.id })
    handleOpenSubCalendar()
    setCalendar(item?.calendar)
  }

  const handleDeleteSubCalendar = item => {
    setSelectedSubCalendar(item)
    openDeleteSubCalendarModal()
  }

  const calendarActions = [
    {
      name: "Book",
      onClick: item => {
        setBookingCalendar(item)
        openCreateBookingModal()
      },
      icon: "bx bx-calendar-plus",
      isAvailable: true,
    },
    {
      name: "Edit",
      onClick: item => {
        getCalendar({ id: item?.id })
        handleOpenCalendar()
      },
      icon: "bx bx-edit",
      isAvailable: true,
    },
    {
      name: "Clone",
      onClick: item => {
        {
          setSelectedCalendar(item)
          openCloneCalendarModal()
        }
      },
      icon: "bx bx-duplicate",
      isAvailable: true,
    },
    {
      name: "Delete",
      onClick: item => {
        setSelectedCalendar(item)
        openDeleteCalendarModal()
        checkCalendarCanBeDeleted({ id: item?.id })
      },
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor))

  const handleDragStart = event => {
    setActiveId(event?.active?.id)
  }

  const handleDragEnd = event => {
    reorderCalendars({
      vendor_id: vendorId,
      calendars: calendarsState?.map((item, index) => ({
        id: item?.id,
        order: index + 1,
      })),
    })
    setActiveId(null)
  }

  const handleDragOver = event => {
    const { active, over } = event
    if (active.id !== over.id) {
      setCalendarsState(items => {
        const oldIndex = items.findIndex(i => i.id === active.id)
        const newIndex = items.findIndex(i => i.id === over.id)

        return arrayMove(items, oldIndex, newIndex)
      })
    }
  }

  const sortCalendarsAlphabetically = () => {
    const items = [...calendarsState]
    items.sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return orderIsAsc ? -1 : 1
      }
      if (nameA > nameB) {
        return orderIsAsc ? 1 : -1
      }

      return 0
    })
    setCalendarsState(items)
    setOrderIsAsc(!orderIsAsc)
    reorderCalendars({
      vendor_id: vendorId,
      calendars: items?.map((item, index) => ({
        id: item?.id,
        order: index + 1,
      })),
    })
  }

  const [reorderableCalendarID, setReorderableCalendarID] = useState(null)

  return (
    <React.Fragment>
      <Row className="my-3 d-flex justify-content-end">
        <Col xs="auto" className="align-self-center">
          <i
            className="bx bx-sort-a-z font-size-22"
            style={{ cursor: "pointer" }}
            onClick={sortCalendarsAlphabetically}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Add New Calendar Group"
            onClick={handleOpenCalendar}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onDragOver={handleDragOver}
          >
            <SortableContext
              id={"calendars"}
              items={calendarsState?.map(calendar => calendar?.id)}
              strategy={() => {}}
            >
              <ListGroup>
                {calendarsState?.map(calendar => {
                  const displayedSubCalendars = allSubCalendars?.filter(
                    subCalendar => subCalendar?.calendar_id === calendar?.id
                  )
                  return (
                    <React.Fragment key={calendar?.id}>
                      <SortableCalendarItem
                        id={calendar?.id}
                        calendar={calendar}
                        addSubCalendarHandler={() => {
                          handleOpenSubCalendar()
                          setCalendar(calendar)
                        }}
                        toggleHandler={() => collapseToggle(calendar?.id)}
                        calendarActions={calendarActions}
                        reorderSubcalendarsHandler={() =>
                          setReorderableCalendarID(calendar?.id)
                        }
                      />
                      {displayedSubCalendars?.length > 0 && (
                        <SubCalendarList
                          isOpen={
                            activeId === calendar?.id
                              ? false
                              : collapseItemIds[calendar?.id]
                          }
                          reorderIsTriggered={
                            reorderableCalendarID === calendar?.id
                          }
                          reordered={() => setReorderableCalendarID(null)}
                          calendarId={calendar?.id}
                          handleBookSubCalendar={handleBookSubCalendar}
                          handleEditSubCalendar={handleEditSubCalendar}
                          handleDeleteSubCalendar={handleDeleteSubCalendar}
                        />
                      )}
                    </React.Fragment>
                  )
                })}
              </ListGroup>
            </SortableContext>
            <DragOverlay>
              {activeId ? (
                <CalendarItem
                  calendar={calendarsState?.find(
                    calendar => calendar?.id === activeId
                  )}
                />
              ) : null}
            </DragOverlay>
          </DndContext>
        </Col>
      </Row>
      <ModalComponent
        title={`Clone Calendar - "${selectedCalendar?.name}"`}
        open={cloneCalendarModalIsOpen}
        onClose={hideCloneCalendarModal}
      >
        <Row className="mb-2">
          <Col>
            <h5>
              Cloning this calendar also clones ALL the booking types from this
              calendar.
            </h5>
          </Col>
        </Row>
        <Row className="my-1 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              color="danger"
              content="Cancel"
              onClick={hideCloneCalendarModal}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Clone"
              loading={loading}
              onClick={() => {
                cloneCalendar({
                  values: {
                    id: selectedCalendar?.id,
                    vendor_id: vendorId,
                  },
                  callback: () => {
                    getBookingCalendars({ type: 2 })
                    getAllCalendars({ type: 2 })
                  },
                })
              }}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        title={`Delete Calendar  - "${selectedCalendar?.name}"`}
        open={deleteCalendarModalIsOpen}
        onClose={hideDeleteCalendarModal}
      >
        {!calendarCanBeDeleted ? (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  Cannot delete calendar with active Bookings. Please cancel all
                  Bookings first.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="OK"
                  onClick={hideDeleteCalendarModal}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  Deleting calendar also deletes ALL booking types from this
                  calendar. This cannot be undone.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="Cancel"
                  onClick={hideDeleteCalendarModal}
                />
              </Col>
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Delete"
                  loading={loading}
                  onClick={() => {
                    deleteCalendar({
                      id: selectedCalendar?.id,
                      callback: () => {
                        getBookingCalendars({ type: 2 })
                        getAllCalendars({ type: 2 })
                      },
                    })
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </ModalComponent>
      <ModalComponent
        title={`Delete Sub Calendar  - "${selectedSubCalendar?.name}"`}
        open={deleteSubCalendarModalIsOpen}
        onClose={hideDeleteSubCalendarModal}
      >
        {selectedSubCalendar?.active_bookings_count > 0 ? (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  In order to be able to delete this sub calendar, you have to
                  first cancel all the bookings for it.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="OK"
                  onClick={hideDeleteSubCalendarModal}
                />
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row className="mb-2">
              <Col>
                <h5>
                  Deleting the sub calendar also deletes ALL bookings from this
                  sub calendar. This cannot be undone.
                </h5>
              </Col>
            </Row>
            <Row className="my-1 d-flex justify-content-end">
              <Col xs="auto">
                <SaveButton
                  type="button"
                  color="danger"
                  content="Cancel"
                  onClick={hideDeleteSubCalendarModal}
                />
              </Col>
              <Col xs="auto">
                <SaveButton
                  type="button"
                  content="Delete"
                  loading={loading}
                  onClick={() => {
                    deleteSubCalendar({
                      id: selectedSubCalendar?.id,
                      callback: () => {
                        getAllSubCalendars({
                          calendar_ids: allCalendars
                            ?.map(calendar => calendar?.id)
                            ?.toString(),
                        })
                      },
                    })
                  }}
                />
              </Col>
            </Row>
          </>
        )}
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  allCalendars: state.BookingsFeature.allCalendars,
  allSubCalendars: state.BookingsFeature.allSubCalendars,
  cloneCalendarModalIsOpen: state.BookingsFeature.cloneCalendarModalIsOpen,
  vendorId: state.Login.vendorId,
  loading: state.BookingsFeature.loading,
  deleteCalendarModalIsOpen: state.BookingsFeature.deleteCalendarModalIsOpen,
  calendarCanBeDeleted: state.BookingsFeature.calendarCanBeDeleted,
  deleteSubCalendarModalIsOpen:
    state.BookingsFeature.deleteSubCalendarModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getAllSubCalendars: values => dispatch(getAllSubCalendars(values)),
  getSubCalendar: values => dispatch(getSubCalendar(values)),
  openCloneCalendarModal: () => dispatch(openCloneCalendarModal()),
  hideCloneCalendarModal: () => dispatch(hideCloneCalendarModal()),
  cloneCalendar: values => dispatch(cloneCalendar(values)),
  getBookingCalendars: values => dispatch(getBookingCalendars(values)),
  getAllCalendars: values => dispatch(getAllCalendars(values)),
  deleteCalendar: values => dispatch(deleteCalendar(values)),
  openDeleteCalendarModal: () => dispatch(openDeleteCalendarModal()),
  hideDeleteCalendarModal: () => dispatch(hideDeleteCalendarModal()),
  checkCalendarCanBeDeleted: values =>
    dispatch(checkCalendarCanBeDeleted(values)),
  getCalendar: values => dispatch(getCalendar(values)),
  openDeleteSubCalendarModal: () => dispatch(openDeleteSubCalendarModal()),
  hideDeleteSubCalendarModal: () => dispatch(hideDeleteSubCalendarModal()),
  deleteSubCalendar: values => dispatch(deleteSubCalendar(values)),
  openCreateBookingModal: () => dispatch(openCreateBookingModal()),
  hideCreateBookingModal: () => dispatch(hideCreateBookingModal()),
  reorderCalendars: values => dispatch(reorderCalendars(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarList)
